import React, { Component } from 'react';
import { QRCodeBox, LeftBoxContainer } from './style';
import { withRouter } from 'react-router-dom';
import QRCode from 'qrcode.react';
import { Row, Column } from '../../../Layouts';
import { Text } from '../../../UI/Text';
import { generateQRCodeLink } from '../../../../Utils';
import { Spinner } from '../../../Components/Spiner/Spiner';

export class CodeBox extends Component {
    state = {
        qrcodeLink: null,
    };

    componentDidMount() {
        generateQRCodeLink({ workout: { id: this.props.match.params.workoutId } }).then(qrcodeLink =>
            this.setState({ qrcodeLink }),
        );
    }

    render() {
        const {
            state: { qrcodeLink },
        } = this;

        return (
            <LeftBoxContainer>
                <Row align={'flex-end'}>
                    <QRCodeBox isEmpty={!qrcodeLink}>
                        {qrcodeLink ? <QRCode value={qrcodeLink} size={86} /> : <Spinner />}
                    </QRCodeBox>

                    <Column height={'auto'} marginLeft={'12px'}>
                        <Text fontSize={18} weight={'bold'} uppercase={true}>
                            Scan to join
                        </Text>
                        <Text fontSize={18} weight={'bold'} uppercase={true}>
                            This class
                        </Text>
                    </Column>
                </Row>
            </LeftBoxContainer>
        );
    }
}

CodeBox = withRouter(CodeBox);



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/Footer/CodeBox.js